export const HOUR_DECIMAL_PLACES = 2;

export const parseHour = (value) => Number.parseFloat(value) || 0;

export const roundHours = (value, decimalPlaces = HOUR_DECIMAL_PLACES) => {
  const num = parseHour(value);
  const factor = 10 ** decimalPlaces;
  return Math.round(num * factor) / factor;
};

export const isHoursZero = (value, decimalPlaces = HOUR_DECIMAL_PLACES) => (
  roundHours(value, decimalPlaces) === 0
);

export const isHoursPositive = (value, decimalPlaces = HOUR_DECIMAL_PLACES) => (
  roundHours(value, decimalPlaces) > 0
);

export const formatDisplayHours = (value, decimalPlaces = HOUR_DECIMAL_PLACES) => (
  `${roundHours(value, decimalPlaces).toFixed(decimalPlaces)}h`
);

export function getUnassignedPillStyles(value) {
  const hours = roundHours(value);
  const isZero = !isHoursPositive(hours);
  return {
    label: formatDisplayHours(hours),
    pillClassName: [
      'ttg-unassigned-pill',
      isZero && 'ttg-unassigned-pill-zero',
    ].filter(Boolean).join(' '),
    pillTextClassName: [
      'ttg-unassigned-pill-text',
      isZero && 'ttg-unassigned-pill-text-zero',
    ].filter(Boolean).join(' '),
  };
}

export default {};
